import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface simModalState {
  isActiveAgentStatus: boolean;
}
const initialState: simModalState = {
  isActiveAgentStatus: false,
};

export const simmodalSlice = createSlice({
  name: "simmodal",
  initialState,
  reducers: {
    setIsModalActive: (state, action: PayloadAction<boolean>) => {
      state.isActiveAgentStatus = action.payload;
    },
    resetSimModal: () => initialState,
  },
});

export const { setIsModalActive, resetSimModal } = simmodalSlice.actions;

export default simmodalSlice.reducer;
